import React from 'react';
import { Box } from '@hover/blueprint';

interface Props {
  desktopImage: React.ReactNode;
  mobileAndTabletImage: React.ReactNode;
}

const HeroImage: React.FC<Props> = ({ desktopImage, mobileAndTabletImage }) => (
  <>
    <Box
      d={{ base: 'block', tablet: 'none', desktop: 'block' }}
      maxH={{ base: 'auto', desktop: '630px' }}
      className="shared-hero__image"
    >
      {desktopImage}
    </Box>
    <Box
      d={{ base: 'none', tablet: 'flex', desktop: 'none' }}
      className="shared-hero__image"
    >
      {mobileAndTabletImage}
    </Box>
  </>
);

export default HeroImage;
